import { gql } from '@apollo/client';
import { Organisation } from '../queries';
import useQuery from '../hooks/useQuery';

export type GetOrgByTenantResponse = {
  organisationsByTenant: Organisation[];
};

export const GET_ORGANIZATION_BY_TENANT = gql`
  query organisationsByTenant($tenantCode: String!) {
    organisationsByTenant(tenantCode: $tenantCode) {
      uuid
      name
      code
      tenantCode
      isActive
    }
  }
`;

export const useGetOrganisationsByTenant = (tenantCode: string) => {
  const { data } = useQuery<Organisation[], GetOrgByTenantResponse>({
    query: GET_ORGANIZATION_BY_TENANT,
    variables: { tenantCode },
    responseField: 'organisationsByTenant',
    refetchByChange: tenantCode,
  });

  return { organisations: data || [] };
};
